import { Component, input, output } from '@angular/core';

@Component({
  selector: 'app-tag',
  standalone: true,
  template: `<ng-content />`,
  styleUrl: './tag.component.scss',
  host: {
    '[class]': 'tagClass()',
    // 只有當 clickable() 為 true 時，才會加上這個 class
    '[class.is-clickable]': 'clickable()', 
    '(click)': 'onHostClick($event)'
  }
})
export class TagComponent {

  size = input<'reserveAdd' | 'healthProfile'|'choosePackage'| 'xs' |'sm' | 'md' | 'lg' | 'none'>('sm');
  color = input<'filled-green' | 'filled-green2' | 'filled-dark-green' | 'outline-orange'| 'outline-purple' | 'outline-purple2' | 'filled-gray' | 'outline-gray' | 'outline-gray2' | 'outline-blue' | 'outline-blue2' | 'outline-green' | 'outline-green2' | 'outline-red'  | 'none'>('filled-green');

  // 強制預設為 false (不可點擊)
  clickable = input<boolean>(false);
  clicked = output<MouseEvent>();

  tagClass() {
    if (this.size() === 'none' || this.color() === 'none') return 'tag-none';
    return `tag-${this.size()} tag-${this.color()}`;
  }

  onHostClick(event: MouseEvent) {
    // 如果沒開啟 clickable，這個 method 根本不會執行 emit
    if (!this.clickable()) return;

    event.stopPropagation();
    this.clicked.emit(event);
  }
}